"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _button = _interopRequireDefault(require("./button"));

var _icon = _interopRequireDefault(require("./icon"));

require("../css/icon_button.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var filledIcons = ['favorite', 'filter', 'profile', 'notification', 'settings'];

var IconButton = function IconButton(_ref) {
  var active = _ref.active,
      className = _ref.className,
      disabled = _ref.disabled,
      icon = _ref.icon,
      loading = _ref.loading,
      otherProps = _objectWithoutProperties(_ref, ["active", "className", "disabled", "icon", "loading"]);

  var appearance = otherProps.appearance,
      buttonProps = _objectWithoutProperties(otherProps, ["appearance"]);

  var buttonClassName = (0, _classnames.default)(_defineProperty({
    'vn-icon-button': true,
    'vn-icon-button--active': active
  }, className, className !== undefined));
  var hasFilledIcon = active && filledIcons.indexOf(icon) !== -1;
  return _react.default.createElement(_button.default, _extends({
    className: buttonClassName,
    disabled: disabled,
    loading: loading
  }, buttonProps), loading === false && _react.default.createElement(_icon.default, {
    name: hasFilledIcon ? "".concat(icon, "-filled") : icon,
    disabled: disabled
  }));
};

IconButton.propTypes = {
  active: _propTypes.default.bool,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.string.isRequired,
  loading: _propTypes.default.bool
};
IconButton.defaultProps = {
  active: false,
  className: '',
  disabled: false,
  loading: false
};
IconButton.displayName = 'IconButton';
var _default = IconButton;
exports.default = _default;